<!-- footer for devices >= lg -->

<div class="container d-none d-lg-block" style="margin-bottom: 18px;">
  <div class="row p-2">
    <div class="col-lg-12">
      <span class="navbar-brand title-footer">Contáctanos</span>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-4 text-center">
      <div class="row p-2">
        <div class="col-lg-12 justify-content-center">
          <small class="text-muted text-left"><span class="footer-font">Descarga la aplicación</span></small>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 text-right nopadding">
          <img src="assets/img/BanCoppel-express-l.png" width="52" height="53">
        </div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-12 text-left">
              <a href="#" class="" (click)="goToIosApp()"><img src="assets/img/App_store_icon-l.png" width="79"
                  height="25"></a>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-left">
              <a href="#" class="" (click)="goToAndroidApp()"><img src="assets/img/Google_play_icon-l.png" width="79"
                  height="25"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4 text-center w-100">
      <div class="row p-0">
        <div class="col-lg-2">
          <a href="#" class=""><img src="assets/img/Divisor_largo.png"></a>
        </div>
        <div class="col-lg-8">
          <div class="row p-2">
            <div class="col-lg-12">
              <small class="text-muted"><span class="footer-font">Visita nuestras Redes Sociales</span></small>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <a href="#" class="" (click)="goToFacebook()"><img src="assets/img/fb-icon.png" width="32" height="32"></a>&nbsp;
              <a href="#" class="" (click)="goToYoutube()"><img src="assets/img/yt-icon.png" width="33" height="33"></a>
            </div>
          </div>
        </div>

        <div class="col-lg-2">
          <a href="#" class=""><img src="assets/img/Divisor_largo.png"></a>
        </div>

      </div>
    </div>


    <div class="col-lg-4">
      <div class="row p-2" style="height: 55px;">
        <div class="col-lg-12 " style="line-height: 1.1;">
          <small class="text-muted text-left"><span class="footer-font">Consulta términos, condiciones, comisiones y
              requisitos de contratación en:</span></small>
        </div>
      </div>
      <div class="row no-padding">
        <div class="col-lg-12 text-center no-padding" style="line-height: 0.6; height: 14px;">
          <a href="#">
            <p class="footer-font-url" (click)="goToWebSite()">www.bancoppel.com</p>
          </a>
        </div>
      </div>
      <div class="row text-center p-2">
        <div class="col-lg-11 justify-content-center nopadding">
          <img src="assets/img/No_Bcoppel.png" width="156" height="25">
        </div>
      </div>
    </div>
  </div>
</div>

<!-- End footer for devices >=lg -->

<!-- Footer for devices = Medium, device -->

<div class="container d-none d-md-block d-lg-none">
  <div class="row p-2">
    <div class="col-12">
      <span class="navbar-brand title-footer">Contáctanos</span>
    </div>
  </div>

  <div class="row">
    <div class="col-4 text-center">
      <div class="row p-2">
        <div class="col-12 justify-content-center">
          <small class="text-muted text-left"><span class="footer-font">Descarga la aplicación</span></small>
        </div>
      </div>
      <div class="row">
        <div class="col-5 text-right nopadding">
          <a href="#" class=""><img src="assets/img/BanCoppel-express.png" width="49" height="50"></a>
        </div>
        <div class="col-7">
          <div class="row">
            <div class="col-12 text-left">
              <a href="#" class="" (click)="goToIosApp()"><img src="assets/img/App_store_icon.png" width="79"
                  height="25"></a>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-left">
              <a href="#" class="" (click)="goToAndroidApp()"><img src="assets/img/Google_play_icon.png" width="79"
                  height="25"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4 text-center">
      <div class="row p-0">

        <div class="col-12">
          <div class="row p-2">
            <div class="col-12">
              <small class="text-muted"><span class="footer-font">Visita nuestras Redes Sociales</span></small>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a href="#" class="" (click)="goToFacebook()"><img src="assets/img/fb-icon.png" width="32" height="32"></a>&nbsp;
              <a href="#" class="" (click)="goToYoutube()"><img src="assets/img/yt-icon.png" width="33" height="33"></a>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="col-4">
      <div class="row p-2 d-none d-md-block d-lg-none" style="height: 55px;">
        <div class="col-12 " style="line-height: 1.1;">
          <small class="text-muted text-left"><span class="footer-font">Consulta términos, condiciones, comisiones y
              requisitos en:</span></small>
        </div>
      </div>
      <div class="row p-2 d-block d-md-none">
        <div class="col-12 ">
          <small class="text-muted text-left"><span class="footer-font">Consulta términos, condiciones, comisiones y
              requisitos en:</span></small>
        </div>
      </div>
      <div class="row no-padding">
        <div class="col-12 text-center no-padding d-none d-md-block d-lg-none" style="line-height: 0.6; height: 14px;">
          <a class="" >
            <p class="footer-font-url" (click)="goToWebSite()" >www.bancoppel.com</p>
          </a>
        </div>
        <div class="col-12 text-center no-padding d-block d-md-none">
          <a class="">
            <p class="footer-font-url-small" (click)="goToWebSite()" >www.bancoppel.com</p>
          </a>
        </div>
      </div>
      <div class="row text-center no-padding">
        <div class="col-11 justify-content-center nopadding">
          <img class="d-none d-md-block d-lg-none" src="assets/img/No_Bcoppel.png" width="156" height="25">
        </div>
      </div>
    </div>
  </div>
</div>


<!-- End footer for devices= Medium, device -->

<!-- Footer for devices <= SMALL Devices -->

<div class="container d-block d-md-none">
  <div class="row p-2">
    <div class="col-12">
      <span class="navbar-brand title-sm-footer">Contáctanos</span>
    </div>
  </div>

  <div class="row">
    <div class="col-12 text-center">
      <div class="row p-2">
        <div class="col-12 justify-content-center">
          <small class="text-muted text-left"><span class="footer-sm-font">Descarga la aplicación</span></small>
        </div>
      </div>
      <div class="row">
        <div class="col-5 text-right nopadding">
          <img src="assets/img/BanCoppel-express@2x.png" width="74" height="75">
        </div>
        <div class="col-7">
          <div class="row">
            <div class="col-12 text-left">
              <a  class="" (click)="goToIosApp()"><img src="assets/img/App_store_icon@2x.png" width="118"
                  height="37"></a>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-left">
              <a  class="" (click)="goToAndroidApp()"><img src="assets/img/Google_play_icon@2x.png" width="118"
                  height="37"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-10">
    <div class="col-12">
      <hr class="col-10">
    </div>
  </div>

  <div class="row p-0">
    <div class="col-12">
      <div class="row p-2">
        <div class="col-12 text-center">
          <small class="text-muted"><span class="footer-sm-font">Visita nuestras Redes Sociales</span></small>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <a  class="" (click)="goToFacebook()"><img src="assets/img/fb-icon@2x.png" width="63" height="63"></a>&nbsp;
          <a  class="" (click)="goToYoutube()"><img src="assets/img/yt-icon@2x.png" width="66" height="66"></a>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-10">
    <div class="col-12">
      <hr class="col-10">
    </div>
  </div>



  <div class="row p-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="row p-2" >
        <div class="col-12 justify-content-center text-center" style="line-height: 1.1;">
          <small class="text-muted text-center"><span class="footer-sm-font">Consulta términos, condiciones, comisiones y
              requisitos de contrataci&oacute;n en:</span></small>
        </div>
      </div>
      <div class="row no-padding" style="height: 30px;">
        <div class="col-12 text-center no-padding d-block d-md-none">
          <a class="" >
            <p class="footer-font-url" (click)="goToWebSite()" >www.bancoppel.com</p>
          </a>
        </div>
      </div>
      <div class="row text-center no-padding">
        <div class="col-12 justify-content-center nopadding">
          <img class="" src="assets/img/No_Bcoppel@2x.png" width="234" height="37">
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>

  <div class="row p-10">
    <div class="col-12">
    &nbsp;
    </div>
  </div>


</div>


<!-- End footer for devices <= SMALL Devices  -->


<!-------------- blue section for devices >= md -->
<div class="d-none d-md-block">
<nav class="navbar navbar-light justify-content-left p-4" style="background-color: #125BA8;">
  <div class="container">
    <div class="row w-100">
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <p class="text-footer">Las promociones ofrecidas en este sitio a trav&eacute;s de BanCoppel son operadas por
              MaxValue de M&eacute;xico S.A. de C.V. Si alguno de los comercios no reconociera la promoci&oacute;n y no
              la hiciera v&aacute;lida, reportarlo al correo electr&oacute;nico: promocionesbancoppel@maxvalue.com.mx o
              al tel&eacute;fono 800 813 6907.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="text-footer">Consulta condiciones, comisiones y requisitos de contrataci&oacute;n de los productos
              BanCoppel en <b style="display: block; cursor: pointer;" (click)="goToWebSite()" >www.bancoppel.com.</b></p>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row">
          <div class="col-12">
            <p class="text-footer"><u><b>ENLACES DE AYUDA</b></u></p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a style="display: block; cursor: pointer;" class="" (click)="goToTCCampanias()"><p class="text-footer">T&eacute;rminos y condiciones de campañas vigentes</p></a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a  style="display: block; cursor: pointer;" class="" (click)="goToAvisoPrivacidad()"><p class="text-footer">Aviso de privacidad</p></a>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12">
            <a href="#" class="" (click)="goToSeguridad()"><p class="text-footer">Seguridad</p></a>
          </div>
        </div> -->
      </div>
      <div class="col-3">
        <div class="row">
          <div class="col-12">
            <a style="display: block; cursor: pointer;" class="" (click)="goToIPAB()"><img src="assets/img/IPAB_Bt.png" alt="IPAB" width="66" height="42"></a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="text-footer">Operaci&oacute;n considerada para la garant&iacute;a hasta por 400 mil UDIS por
              persona por instituci&oacute;n <a style="display: block; cursor: pointer;" class="" (click)="goToIPAB()"><u>www.ipab.org.mx</u></a></p>
            <p class="text-footer"><b>IPAB</b> solo aplica para <b>Tarjeta de D&eacute;bito BanCoppel</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
</div>
<!-- END------blue section for devices >= md -->

<!-------------- blue section for devices < md -->
<div class="d-block d-md-none">
  <nav class="navbar navbar-light justify-content-center p-4" style="background-color: #125BA8;">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <p class="text-footer">Las promociones ofrecidas en este sitio a trav&eacute;s de BanCoppel son operadas por
                MaxValue de M&eacute;xico S.A. de C.V. Si alguno de los comercios no reconociera la promoci&oacute;n y no
                la hiciera v&aacute;lida, reportarlo al correo electr&oacute;nico: promocionesbancoppel@maxvalue.com.mx o
                al tel&eacute;fono 800 813 6907.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="text-footer">Consulta condiciones, comisiones y requisitos de contrataci&oacute;n de los productos
                BanCoppel en <span  class="url-yellow" (click)="goToWebSite()" >www.bancoppel.com</span>.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <p class="text-footer"><u><b>ENLACES DE AYUDA</b></u></p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a class="" (click)="goToTCCampanias()"><p class="text-footer">T&eacute;rminos y condiciones de campañas vigentes</p></a>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a class="" (click)="goToAvisoPrivacidad()"><p class="text-footer">Aviso de privacidad</p></a>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-12">
              <a href="#" class="" (click)="goToSeguridad()"><p class="text-footer">Seguridad</p></a>
            </div>
          </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-3">
              <a style="display: block; cursor: pointer;" class="" (click)="goToIPAB()"><img src="assets/img/IPAB_Bt.png" alt="IPAB" width="66" height="42"></a>
            </div>
            <div class="col-9">
              <p class="text-footer">Operaci&oacute;n considerada para la garant&iacute;a hasta por 400 mil UDIS por
                persona por instituci&oacute;n <a style="display: block; cursor: pointer;" class="" (click)="goToIPAB()"><u>www.ipab.org.mx</u></a></p>
              <p class="text-footer"><b>IPAB</b> solo aplica para <b>Tarjeta de D&eacute;bito BanCoppel</b></p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </nav>
  </div>
  <!-- END------blue section for devices >= md -->
